import { initializeApp, getApps, getApp, FirebaseApp } from 'firebase/app';
import { getAuth, Auth } from 'firebase/auth';

let firebaseApp: FirebaseApp;
let firebaseAuth: Auth;

/**
 * Initializes the Firebase application.
 * This function fetches the Firebase config from a reserved URL,
 * which is populated by Firebase Hosting in deployed environments
 * and by the Firebase Emulator Suite during local development.
 */
const setupFirebase = async (): Promise<void> => {
  if (getApps().length > 0) {
    firebaseApp = getApp();
  } else {
    try {
      const response = await fetch('/__/firebase/init.json');
      const firebaseConfig = await response.json();
      firebaseApp = initializeApp(firebaseConfig);
    } catch (error) {
      console.error('Failed to fetch Firebase config. Are you running the Firebase Hosting emulator?', error);
      throw new Error('Could not initialize Firebase. Please ensure the hosting emulator is running.');
    }
  }
  firebaseAuth = getAuth(firebaseApp);
};

/**
 * Returns the initialized Firebase Auth instance.
 * Throws an error if Firebase has not been initialized.
 */
export const getFirebaseAuth = (): Auth => {
  if (!firebaseAuth) {
    throw new Error('Firebase Auth has not been initialized. Please call setupFirebase first.');
  }
  return firebaseAuth;
};

/**
 * Returns the initialized Firebase App instance.
 * Throws an error if Firebase has not been initialized.
 */
export const getFirebaseApp = (): FirebaseApp => {
  if (!firebaseApp) {
    throw new Error('Firebase App has not been initialized. Please call setupFirebase first.');
  }
  return firebaseApp;
};

export default setupFirebase;
